import {
  Repository,
  Team,
  eventSchema,
  repositorySchema,
  teamSchema,
} from '@basehub/data/replicache/index'
import { z } from 'zod'

export const publicRepoSchema = repositorySchema.pick({
  id: true,
  slug: true,
  contributors: true,
  createdAt: true,
  isPublic: true,
  title: true,
  description: true,
  latestCommit: true,
  stats: true,
  forkStatus: true,
  previewUrl: true,
  gitRepoUrl: true,
  readme: true,
  guests: true,
  lastTransferredAt: true,
})

export type PublicRepo = z.infer<typeof publicRepoSchema>

export const publicTeamSchema = teamSchema
  .pick({
    avatarUrl: true,
    createdAt: true,
    description: true,
    id: true,
    slug: true,
    title: true,
    members: true,
  })
  .extend({
    publicRepos: publicRepoSchema.array().nullish(),
    publicEvents: eventSchema.array().nullish(),
  })
  .transform((team) => {
    return {
      ...team,
      isPublic: true as const,
    }
  })

export type PublicTeam = z.infer<typeof publicTeamSchema>

// type casts

export function isPublicRepo(
  repo: PublicRepo | Repository | null | undefined
): repo is PublicRepo {
  return !!repo && 'tokens' in repo === false
}

export function isForkableRepo<
  Repo extends PublicRepo | Repository | null | undefined,
>(repo: Repo): repo is NonNullable<Repo> {
  return Boolean(repo?.isPublic)
}

export function isUserRepo(
  repo: PublicRepo | Repository | null | undefined
): repo is Repository {
  return !!repo && 'tokens' in repo
}

export function isPublicTeam(
  team: PublicTeam | Team | null | undefined
): team is PublicTeam {
  return !!team && 'isPublic' in team
}

export function isUserTeam(
  team: PublicTeam | Team | null | undefined
): team is Team {
  return !!team && 'isPublic' in team === false
}
